import { compose, applyMiddleware, createStore } from 'redux';
import { persistCombineReducers } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';
import { routerReducer as router, routerMiddleware } from 'react-router-redux';
import { createLogger } from 'redux-logger';
// import io from 'socket.io-client';
import { disableReactDevTools } from './components/common/util';
// import { disableReactDevTools, hlog } from './components/common/util';
// import { disableReactDevTools } from './components/common/util';
import { CONFIG } from './config';
import history from './hhHistory';
import tags from './reducers/tag';
import chat from './reducers/chat';
import user from './reducers/user';
import view from './reducers/view';
import event from './reducers/event';
import steps from './reducers/steps';
import loader from './reducers/loader';
import projects from './reducers/project';
import cmsEvents from './reducers/cmsEvent';
import stripeCards from './reducers/stripeCard';
import userTickets from './reducers/userTickets';
import notifications from './reducers/notifications';
import cmsEventInfo from './reducers/cmsEventInfo';
import cmsEventInvoices from './reducers/cmsEventInvoices';
import cmsEventAwards from './reducers/cmsEventAward';
import cmsEventTopics from './reducers/cmsEventTopic';
import cmsEventScreening from './reducers/cmsEventScreening';
import cmsEventApplicationForm from './reducers/cmsEventApplicationForm';
import cmsEventRankingAwards from './reducers/cmsEventRankingAwards';
import cmsEventTickets from './reducers/cmsEventTicket';
import cmsEventJudges from './reducers/cmsEventJudge';
import cmsEventMultiRoundJudges from './reducers/cmsEventMultiRoundJudge';
import cmsEventMentors from './reducers/cmsEventMentor';
import cmsEventVolunteers from './reducers/cmsEventVolunteer';
import cmsEventRankings from './reducers/cmsEventRanking';
import eventSubmissions from './reducers/eventSubmission';
import cmsEventManagers from './reducers/cmsEventManager';
import cmsEventParticipants from './reducers/cmsEventParticipant';
import cmsEventJudgingCriteria from './reducers/cmsEventJudgingCriteria';
import cmsEventAnnouncements from './reducers/cmsEventAnnouncements';
import cmsUploadsList from './reducers/cmsUploadsList';
import socialMedia from './reducers/socialMedia';
import xinshiUser from './reducers/xinshiUser';
import permissions from './reducers/permissions';
import initialEvents from './reducers/initialEvents';
import eventList from './reducers/eventList';
import publicPostings from './reducers/publicPostings';
// import createSocketMiddleware from './reduxMiddleware/socketMiddleware';
// import { Config } from './reduxMiddleware/socketConfig';
import cmsEventRankingMultiRound from './reducers/cmsEventRankingMultiRound';

const reducers = persistCombineReducers(
  {
    key: 'primary',
    storage,
    blacklist: [
      'form',
      'cmsEvents',
      'cmsEventInfo',
      'cmsEventManagers',
      'cmsEventJudges',
      'cmsEventMultiRoundJudges',
      'cmsEventMentors',
      'cmsEventVolunteers',
      'cmsEventParticipants',
      'cmsEventRankings',
      'cmsEventJudgingCriteria',
      'cmsEventInvoices',
      'cmsEventAwards',
      'cmsEventTopics',
      'cmsEventScreening',
      'cmsEventApplicationForm',
      'cmsEventRankingAwards',
      'cmsEventTickets',
      'cmsEventAnnouncements',
      'cmsUploadsList',
      'notifications'
    ]
  },
  {
    loader,
    user,
    projects,
    tags,
    chat,
    steps,
    notifications,
    cmsEvents,
    cmsEventInfo,
    cmsEventManagers,
    cmsEventJudges,
    cmsEventMultiRoundJudges,
    cmsEventMentors,
    cmsEventVolunteers,
    cmsEventParticipants,
    cmsEventRankings,
    cmsEventRankingMultiRound,
    cmsEventJudgingCriteria,
    cmsEventInvoices,
    cmsEventAwards,
    cmsEventTopics,
    cmsEventScreening,
    cmsEventApplicationForm,
    cmsEventRankingAwards,
    cmsEventTickets,
    cmsEventAnnouncements,
    cmsUploadsList,
    eventSubmissions,
    stripeCards,
    userTickets,
    view,
    event,
    router,
    xinshiUser,
    permissions,
    socialMedia,
    initialEvents,
    eventList,
    publicPostings
  }
);

const middleware = [];
middleware.push(thunk);

let composeEnhancers = compose;

const devTools = f => f;
if (CONFIG.DEV) {
  middleware.push(createLogger());
  composeEnhancers =
    typeof window === 'object' &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
      }) : compose;
} else {
  disableReactDevTools();
}


middleware.push(routerMiddleware(history));

// const socket = io(Config.socketUrl, {
//   reconnection: true,
//   reconnectionAttempts: Config.attempts,
//   reconnectionDelay: Config.delay,
//   timeout: Config.timeOut
// });

// if (socket) {
//   const socketMiddleware = createSocketMiddleware(socket);
//   middleware.push(socketMiddleware);
//   socket.on('connection_error', (err) => {
//     hlog(err);
//   });
//   socket.on('connection_timeOut', () => {
//     hlog('socket connection timeout');
//   });
//   setInterval(() => {
//     socket.emit('ping');
//   }, Config.pingInterval);
// }

const store = createStore(
  reducers,
  undefined,
  composeEnhancers(
    applyMiddleware(...middleware),
    devTools,
  )
);

export default store;



// WEBPACK FOOTER //
// ./src/store.js